const loginErrorMessage = document.getElementById('MemberLoginForm_LoginForm_error')
const signInButton = document.querySelector('.btn-toolbar')
const forgotPassword = document.getElementById('ForgotPassword')

if (loginErrorMessage && loginErrorMessage.classList.contains('bad')) {
  loginErrorMessage.parentNode.removeChild(loginErrorMessage)
  signInButton.parentNode.insertBefore(loginErrorMessage, signInButton)
  loginErrorMessage.style.display = 'block'
  const helpLink = document.createElement('a')
  helpLink.setAttribute('href', '/help-centre/')
  helpLink.innerHTML = 'Having trouble? Visit our help centre'
  forgotPassword.appendChild(helpLink)
}

const passwordErrorMessage = document.getElementById('ChangePasswordForm_ChangePasswordForm_error')
if (passwordErrorMessage && passwordErrorMessage.classList.contains('bad')) {
  passwordErrorMessage.parentNode.removeChild(passwordErrorMessage)
  signInButton.parentNode.insertBefore(passwordErrorMessage, signInButton)
  passwordErrorMessage.style.display = 'block'
}
